/**
 * 分为三级权重，最后扁平化处理
 * 1.匹配标题上的文案
 * 2.匹配borad id
 * 3.匹配拼音
 **/
interface boardData {
  withPinyinBoards: Array<{
    title: string;
    board_id: Number;
    _pinyin: Array<Array<string>>;
  }>;
}
export const filterBoards = (keyword: string, boardData: boardData) => {
  let boards = [[], [], []];
  if (keyword) {
    const keywordToLowerCase = keyword.toLowerCase().trim();
    boardData?.withPinyinBoards.forEach((board) => {
      // 匹配标题上的文案
      if (board.title.toLowerCase().includes(keywordToLowerCase)) {
        boards[0].push(board);
        // 匹配borad id
      } else if (board.board_id.toString() === keywordToLowerCase) {
        boards[1].push(board);
      } else {
        // 全拼音匹配
        const isPinyinMatch = board._pinyin
          .join("")
          .includes(keywordToLowerCase);
        // 首字母匹配
        const isFirstLetterMatch = board._pinyin
          .map((i) => i[0])
          .join("")
          .includes(keywordToLowerCase);
        if (isPinyinMatch || isFirstLetterMatch) {
          boards[2].push(board);
        }
      }
    });
  }
  return boards.flat();
};
